// A stage's colour by its place on the board: stages take these in turn, each unlike the one before, and a resolved
// stage has its own green. The same in light and dark, and the same values as the mobile app's (STAGE_FILL in
// uvx-app's src/components/StagePager.tsx)
const FILLS = [
  'bg-[#0090ff]', // blue
  'bg-[#ffc53d]', // amber
  'bg-[#fd6262]', // coral
  'bg-[#6e56cf]', // violet
  'bg-[#00a2c7]', // cyan
  'bg-[#f76b15]', // orange
  'bg-[#d6409f]', // pink
  'bg-[#ad7f58]', // brown
];

export const stageFill = (index, resolved) =>
  resolved ? 'bg-[#30a46c]' : FILLS[index % FILLS.length];
